import gql from 'graphql-tag';

const CREATE_CATALOG_SPEC = gql`
  mutation catalogSpec($label: String!, $name: String!) {
    catalogSpec: createCatalogSpec(label: $label, name: $name) {
      id,
      label,
      name
    }
  }
`;

export default CREATE_CATALOG_SPEC;
